export const OP_CATEGORY = [
  {
    key: 'category-0',
    value: 'all',
    label: "Tất cả"
  },
  {
    key: 'category-1',
    value: 'lottery',
    label: "Xổ số"
  },
  {
    key: 'category-2',
    value: 'casino',
    label: "Game Việt"
  },
]

export const OP_GAME_ORIGINALS = [
  {
    key: 'originnal-0',
    value: 'hilo',
    label: "Hilo"
  },
  {
    key: 'originnal-1',
    value: 'video-poker',
    label: "Poker"
  },
  {
    key: 'originnal-2',
    value: 'keno',
    label: "Keno"
  }
]

export const XOC_DIA_PRIZES = {
  '4do': 'Chẵn - Tài - 4 Đỏ',
  '4trang': 'Chẵn - Xỉu - 4 Trắng',
  '2do-2trang': 'Chẵn - Hòa - 2 Đỏ 2 Trắng',
  '3do-1trang': 'Lẻ - Tài - 3 Đỏ 1 Trắng',
  '1do-3trang': 'Lẻ - Xỉu - 1 Đỏ 3 Trắng',
};